import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { BaseComponent } from '../base/base.component';
import { Commission_Rule, Price_Type, Store } from '../../models/RestModels';

@Component({
	selector: 'app-list-commission-rule',
	templateUrl: './list-commission-rule.component.html',
	styleUrls: ['./list-commission-rule.component.css']
})
export class ListCommissionRuleComponent extends BaseComponent implements OnInit
{
	commission_rule_list:Commission_Rule[] = [];
	store_list:Store[] = [];
	price_type_list:Price_Type[] = [];
	selected_rule:Commission_Rule = this.getEmptyRule();

	ngOnInit()
	{
		this.setTitle('Reglas de comisiones');
		this.load();
	}

	getEmptyRule():Commission_Rule
	{
		return {
			id: 0,
			base_percent: 0,
			created: new Date(),
			created_by_user_id: this.rest.current_user?.id || 0,
			discount_reduction_per_percent: 0,
			price_type_id: null,
			status: 'ACTIVE',
			store_id: null,
			updated: new Date(),
			updated_by_user_id: this.rest.current_user?.id || 0
		};
	}

	load()
	{
		this.is_loading = true;
		this.subs.sink = forkJoin({
			commission_rules: this.rest.commission_rule.search({ limit: 9999, sort_order: ['store_id_asc','price_type_id_asc'] }),
			stores: this.rest.store.search({ limit: 9999, sort_order: ['name_asc'] }),
			price_types: this.rest.price_type.search({ limit: 9999, sort_order: ['sort_priority_asc','name_asc'] })
		}).subscribe((response)=>
		{
			this.commission_rule_list = response.commission_rules.data;
			this.store_list = response.stores.data;
			this.price_type_list = response.price_types.data;
			this.is_loading = false;
		},(error)=>this.showError(error));
	}

	selectRule(rule:Commission_Rule)
	{
		this.selected_rule = { ...rule };
	}

	newRule()
	{
		this.selected_rule = this.getEmptyRule();
	}

	getStoreName(store_id:number):string
	{
		return this.store_list.find(s=>s.id == store_id)?.name || ''+store_id;
	}

	getPriceTypeName(price_type_id:number):string
	{
		return this.price_type_list.find(pt=>pt.id == price_type_id)?.name || ''+price_type_id;
	}

	hasDuplicate():boolean
	{
		return this.commission_rule_list.some(rule=>
			rule.id != this.selected_rule.id
			&& rule.store_id == this.selected_rule.store_id
			&& rule.price_type_id == this.selected_rule.price_type_id
		);
	}

	save()
	{
		if( this.hasDuplicate() )
		{
			this.showError('Ya existe una regla para esa sucursal y tipo de precio');
			return;
		}

		this.is_loading = true;
		const request = this.selected_rule.id
			? this.rest.commission_rule.update(this.selected_rule)
			: this.rest.commission_rule.create(this.selected_rule);

		this.subs.sink = request.subscribe(()=>
		{
			this.showSuccess('La regla se guardo exitosamente');
			this.newRule();
			this.load();
		},(error)=>this.showError(error));
	}
}
